import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import React, { useState, useEffect } from 'react';
import { getSelectData } from '../../../../utils/api/data';
import Cookies from 'js-cookie';

const StepFour = ({ formData, onChange, isGtmsCp }) => {
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [localFormData, setLocalFormData] = useState(formData || {});
    const gtmsCustomer = isGtmsCp ?? Cookies.get('cp-cn') === 'GTMS-CP';
    const currentFormData = localFormData;

    useEffect(() => {
      setLocalFormData(formData || {});
    }, [formData]);

    useEffect(() => {
      const getDestinationData = async () => {
        try {
          const response = await getSelectData({
            selectValues: 'CONSIGNEE_NAME, CONSIGNEE_ADDRESS_1, CONSIGNEE_CONTACT, CONSIGNEE_PHONE, CONSIGNEE_EMAIL, OPEN_TIME, CLOSE_TIME, DELIVERY_NUMBER',
            tableName: 'forms.BIOVATIONS_VENDORS_DESTINATION_INFORMATION ',
            whereField: 'CONSIGNEE_NAME',
            whereValue: 'Biovation HQ',
          });

          if (response && response.length > 0) {
            const consigneeData = response[0];
            const updatedFormData = {
              consigneeName: consigneeData.CONSIGNEE_NAME,
              consigneeAddress1: consigneeData.CONSIGNEE_ADDRESS_1,
              consigneeContact: consigneeData.CONSIGNEE_CONTACT,
              consigneePhone: consigneeData.CONSIGNEE_PHONE,
              consigneeEmail: consigneeData.CONSIGNEE_EMAIL,
              consigneeOpenTime: consigneeData.OPEN_TIME,
              consigneeCloseTime: consigneeData.CLOSE_TIME,
              deliveryNumber: consigneeData.DELIVERY_NUMBER
            };

            setLocalFormData(prevState => ({ ...prevState, ...updatedFormData }));
            onChange({ ...(formData || {}), ...updatedFormData });
          }
        } catch (error) {
          console.error("Error fetching destination data:", error);
        }
      }

      if (!gtmsCustomer) {
        getDestinationData();
      }
    }, [gtmsCustomer]);
  
    const handleCheckboxChange = (event) => {
      setIsCheckboxChecked(event.target.checked);
    };

    const handleChange = (e) => {
      const { id, value } = e.target;
      const updatedFormData = { ...localFormData, [id]: value };
      setLocalFormData(updatedFormData);
      onChange(updatedFormData);
    };

  return (
    <div className="BiovationDomStepEight">
      <div className="BiovationFormContainer">
        <div className="BiovationFormFieldsStep2">
          <div className="BiovationColumn">
            <div className="BiovationDomField">
              <TextField size="small" id="consigneeName" label="Consignee Name" 
                variant="outlined" value={currentFormData?.consigneeName || ''} 
                onChange={handleChange} required
              />
            </div>
            <div className="BiovationDomField">
              <TextField  size="small" id="consigneeAddress1" label="Consignee Address 1" 
              variant="outlined" value={currentFormData?.consigneeAddress1 || ''} 
              onChange={handleChange} required
              />
            </div>
            <div className="BiovationDomField">
              <TextField size="small" id="consigneeAddress2" label="Consignee Address 2" 
              variant="outlined" value={currentFormData?.consigneeAddress2 || ''} 
              onChange={handleChange}
              />
            </div>
            <div className="BiovationDomField">
              <TextField size="small" id="consigneeContact" label="Consignee Contact" 
              variant="outlined" value={currentFormData?.consigneeContact || ''} 
              onChange={handleChange} required
              />
            </div>
            <div className="BiovationDomField">
              <TextField size="small" id="consigneePhone"label="Consignee Phone" 
              variant="outlined" value={currentFormData?.consigneePhone || ''} 
              onChange={handleChange} required
              />
            </div>
          </div>
          <div className="BiovationColumn">
            <div className="BiovationDomField">
              <TextField size="small" id="consigneeEmail" label="Consignee Email" 
              variant="outlined" value={currentFormData?.consigneeEmail || ''} 
              onChange={handleChange} required
              />
            </div>
            <div className="BiovationDomField">
              <TextField  size="small" id="consigneeOpenTime" label="Open Time" 
                variant="outlined" value={currentFormData?.consigneeOpenTime || ''} onChange={handleChange} 
                required
              />
            </div>
            <div className="BiovationDomField">
              <TextField  size="small" id="consigneeCloseTime" label="Close Time" 
                variant="outlined" value={currentFormData?.consigneeCloseTime || ''} onChange={handleChange} 
                required
              />
            </div>
            <div className="BiovationDomField">
              <TextField  size="small" id="deliveryNumber" label="Delivery Number" 
                variant="outlined" value={currentFormData?.deliveryNumber || ''} onChange={handleChange} 
                required
              />
            </div>
            <div className="BiovationFirstServe">
              <label>
                <Checkbox checked={isCheckboxChecked} onChange={handleCheckboxChange}/>
                Is dock first come first serve?
              </label>
              <TextField
                size="small" id="deliveryDockFirstServe" label="Include all delivery information here" 
                variant="outlined" value={currentFormData?.deliveryDockFirstServe || ''} onChange={handleChange} 
                disabled={!isCheckboxChecked} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepFour
